export const buttonRouteMapper: Record<string, string> = {
  portfolios: '/catalog',
  'fixed-income': '/products-view/catalog/fixed-income',
  'government-bond': '/products-view/catalog/government-bond',
  funds: '/products-view/catalog/funds',
  'custom-operation': '/products-view/catalog/structured-operation',
  'initial-public-offering': '/products-view/catalog/initial-public-offering',
  'variable-income': '/trade/search'
};
